import React, { useEffect, useState } from "react";
import {
  CareemDeliveryStatusKeys,
  CareemDeliveryStatus as CareemStatusMap,
  JeeblyDeliveryStatusKeys,
  JeeblyDeliveryStatus as JeeblyStatusMap,
  SliderDeliveryStatusKeys,
  SliderDeliveryStatus as SliderStatusMap,
} from "config/Constants";
import { INTEGRATION_NAMES } from 'logistic-integrations/constants';
import { useGetLogisticStatus } from 'hooks/useOrder';

const CareemStatus = [CareemDeliveryStatusKeys.UPCOMING,
  CareemDeliveryStatusKeys.DELIVERY_STARTED,
  CareemDeliveryStatusKeys.CAPTAIN_ASSIGNED,]

const JeeblyStatus = [JeeblyDeliveryStatusKeys.PICKUP_SCHEDULED,
  JeeblyDeliveryStatusKeys.ASSIGNED,
  JeeblyDeliveryStatusKeys.UNASSIGNED,
  JeeblyDeliveryStatusKeys.REACHED_CUSTOMER_LOCATION,]

const SliderStatus = [SliderDeliveryStatusKeys.PENDING,
  SliderDeliveryStatusKeys.IN_PROGRESS,
  SliderDeliveryStatusKeys.CANCELLED,
  SliderDeliveryStatusKeys.FAILED,
  SliderDeliveryStatusKeys.RETURNED_TO_SENDER,]


  const StatusKeyMap = {
    [INTEGRATION_NAMES.CAREEM_NOW]: {status: CareemStatus, statusMap: CareemStatusMap},
    [INTEGRATION_NAMES.JEEBLY]: {status: JeeblyStatus, statusMap: JeeblyStatusMap},
    [INTEGRATION_NAMES.SLIDER]: {status: SliderStatus, statusMap: SliderStatusMap},
  }
  const allowedLogisticPartners = [INTEGRATION_NAMES.CAREEM_NOW, INTEGRATION_NAMES.JEEBLY, INTEGRATION_NAMES.SLIDER];

const LogisticStatus = ({ orderId, logisticPartner }) => {
  const activeLogisticPartner = allowedLogisticPartners.includes(logisticPartner)
    ? logisticPartner
    : null;

  const [pollStatus, setPollStatus] = useState(true);

  const { data: logisticData } = useGetLogisticStatus({
    orderId: activeLogisticPartner ? orderId : null,
    status: pollStatus,
    integrationName: activeLogisticPartner,
  });

  useEffect(() => {
    if (!activeLogisticPartner || !logisticData?.data?.status) return;
    const pendingKeys = StatusKeyMap[activeLogisticPartner]?.status;
    setPollStatus(pendingKeys?.includes(logisticData.data.status) ?? false);
  }, [logisticData, activeLogisticPartner]);

  if (!activeLogisticPartner || !orderId) {
    return null;
  }

  return (
    <span
      className="blink"
      style={{
        color: StatusKeyMap[activeLogisticPartner]?.statusMap[logisticData?.data?.status]?.color ?? "red",
      }}
    >
      {StatusKeyMap[activeLogisticPartner]?.statusMap[logisticData?.data?.status]?.label ?? "Pending"}
    </span>
  )
}

export default LogisticStatus